<template>
    <b-container>
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Tarifas</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" lg="3" class="mt-4 mb-2 d-none d-lg-block">
                <b-button variant="default" pill block size="sm" title="Agregar" @click="infoData" v-b-modal.data>
                    <i class="material-icons mdi mdi-cash-plus"></i>&nbsp;
                    <span>Nueva Tarifa</span>
                </b-button>
            </b-col>
            <b-col cols="12" lg="9" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar"
                            class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''"
                                class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-table :items="items" :fields="fields" responsive="sm" class="my-2 border-bottom" stacked="sm" hover
                    small show-empty no-border-collapse table-variant="light" details-td-class="px-0"
                    empty-filtered-text="No hay tarifas que coincidan con la búsqueda"
                    empty-text="No hay tarifas para mostrar" :current-page="currentPage" :per-page="perPage"
                    :filter="search" :busy="isBusy" @filtered="onFiltered">
                    <template #cell(actions)="row">
                        <b-button variant="default" size="sm" title="Editar" @click="infoData(row.item.id)"
                            v-b-modal.data>
                            <i class="material-icons">edit</i>
                        </b-button>
                        <b-button variant="default" size="sm" title="Agentes" @click="showAgentModal(row.item.id)"
                            v-b-modal.dataAgent>
                            <i class="material-icons">assured_workload</i>
                        </b-button>
                        <b-button variant="danger" size="sm" title="Eliminar" @click="trash(row.item.id)">
                            <i class="material-icons">delete</i>
                        </b-button>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>
                </b-table>

                <!-- Modal Add/Edit Fee CURRENT-->
                <b-modal id="data" centered no-fade header-class="text-center" header-bg-variant="primary"
                    header-text-variant="light" header-close-variant="light" footer-class="border-0" hide-footer
                    body-class="text-center px-4 my-4" :title="(form.id ? 'Actualizar' : 'Agregar Nueva') + ' Tarifa'"
                    tabindex="-1" role="dialog" size="lg" aria-hidden="true">
                    <b-form id="formData" @submit.stop.prevent="form.id !== 0 ? save(form.id) : save()">
                        <b-row class="justify-content-center">
                            <template v-for="(v, k) in form.values">
                                <b-col cols="12" md="10" align-self="start" v-if="v.key === 'country'">
                                    <h6 class="pt-2">
                                        <u>Paises</u>
                                    </h6>
                                </b-col>
                                <b-col cols="12" md="10" align-self="start" v-if="v.key === 'value'" class="text-left">
                                    <b-form-group label="Aplicar valor a todos los Agentes">
                                        <b-form-checkbox-group
                                                id="partners"
                                                switches>
                                                <b-form-checkbox name="check-apply-all" v-model="v.check_apply_all">
                                                </b-form-checkbox>
                                        </b-form-checkbox-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="5" align-self="start">
                                    <b-form-group :label="labels.values[k].name + ':'">
                                        <b-form-select v-if="v.items" :name="'value' + k"
                                            :options="v.items" :value="v.value"
                                            v-model="v.value" class="form-control text-center"
                                            v-validate="'required:true'" :state="validateState('value' + k)"
                                            :data-vv-as="(labels.values[k].name).toLowerCase()" :disabled="loading"
                                            :aria-describedby="'value' + k + '-live-feedback'" value-field="code"
                                            text-field="name">
                                        </b-form-select>
                                        <b-form-input v-else :name="'value' + k" v-model="v.value"
                                            :type="v.key === 'value' || v.key === 'com' || v.key === 'tax' || v.key === 'min' || v.key === 'max' ? 'number' : 'text'"
                                            :step="v.key === 'value' || v.key === 'com' || v.key === 'tax' || v.key === 'min' || v.key === 'max' ? '0.01' : ''"
                                            class="text-center"
                                            v-validate="(v.key === 'payer' || v.key === 'payer_id' || v.key === 'country' || v.key === 'destiny' ? '' : 'required:true')"
                                            :state="validateState('value' + k)"
                                            :data-vv-as="(labels.values[k].name).toLowerCase()" :disabled="loading"
                                            :aria-describedby="'value' + k + '-live-feedback'" />
                                        <b-form-invalid-feedback :id="'value' + k + '-live-feedback'">
                                            {{ veeErrors.first('value' + k) }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </template>
                        </b-row>
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="10" align-self="start" class="my-4">
                                <b-button type="submit" variant="default" size="lg" pill class="align-middle px-5"
                                    form="formData" :disabled="loading">
                                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                                    <b-icon icon="upload" aria-hidden="true" class="align-middle" v-else></b-icon>
                                    &nbsp;&nbsp;<span>{{ loading ? (form.id === 0 ? 'Guardando...' : 'Actualizando...')
                                        : (form.id === 0
                                            ? 'Guardar' : 'Actualizar') }}</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-modal>

                <!-- Modal Add/Edit Agent Fee NEW MODAL-->
                <b-modal id="dataAgent" centered no-fade header-class="text-center" header-bg-variant="primary"
                    header-text-variant="light" header-close-variant="light" footer-class="border-0" hide-footer
                    body-class="text-left px-4 my-4" :title="'Tarifas Agentes'" tabindex="-1" role="dialog" size="lg"
                    aria-hidden="true">
                    <b-form id="formAgent" @submit.stop.prevent="saveAgentTariff()">
                        <b-table :items="agentFees" :fields="agentFields" responsive="sm" class="my-2 border-bottom"
                            stacked="sm" hover small show-empty no-border-collapse table-variant="light"
                            empty-text="No hay agentes para mostrar">
                            <template #cell(type)="row">
                                <b-form-select v-model="row.item.type" class="form-control text-center" :disabled="loading">
                                    <b-form-select-option value="=">Valor Fijo</b-form-select-option>
                                    <b-form-select-option value="%">Porcentaje</b-form-select-option>
                                </b-form-select>
                            </template>
                            <template #cell(value)="row">
                                <b-form-input v-model="row.item.value" type="number" step="0.01" class="text-center"
                                    :disabled="loading" />
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-4">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Actualizando...</strong>
                                </div>
                            </template>
                        </b-table>
                    </b-form>
                    <b-row class="justify-content-center">
                        <b-col cols="12" md="10" align-self="start" class="my-4">
                            <b-button type="submit" variant="default" size="lg" pill class="align-middle px-5"
                                form="formAgent" :disabled="loading"
                                v-b-modal.editAgent>
                                <b-icon icon="upload" aria-hidden="true" class="align-middle"></b-icon>
                                &nbsp;&nbsp;<span>Actualizar agentes</span>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-modal>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group label="Mostrar:" label-for="per-page-select" label-cols-sm="4" label-cols-md="6"
                    label-cols-lg="9" label-align-sm="right" label-size="sm" class="mt-2 mb-8">
                    <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"
                        size="sm"></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm"
                    class="mt-2 mb-8"></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "Fee",
    data: () => ({
        labels: {
            values: [
                { name: 'Corresponsal' },
                { name: 'Pagador' },
                { name: 'Valor' },
                { name: 'Tipo de Tarifa' },
                { name: 'Costo' },
                { name: 'Tipo de Costo' },
                { name: 'Impuestos' },
                { name: 'Moneda (ISO 20022)' },
                { name: 'Remitente (ISO 2)' },
                { name: 'Destinatario (ISO 2)' },
                { name: 'Rango Min' },
                { name: 'Rango Max' },
            ]
        },
        form: {
            id: 0,
            item: null,
            payer: null,
            payer_id: null,
            value: 0,
            com: 0,
            currency: null,
            range: null,
            country: 'CL',
            check_apply_all: 0,
            values: [
                { key: 'payer', value: null },
                { key: 'payer_id', value: null },
                { key: 'value', value: 0 },
                {
                    key: 'type', value: null, items: [
                        { code: '=', name: 'Valor Fijo' },
                        { code: '%', name: 'Porcentaje' }
                    ]
                },
                { key: 'com', value: 0 },
                {
                    key: 'tc', value: null, items: [
                        { code: '=', name: 'Valor Fijo' },
                        { code: '%', name: 'Porcentaje' }
                    ]
                },
                { key: 'tax', value: 0.19 },
                { key: 'currency', value: 'USD' },
                { key: 'country', value: null },
                { key: 'destiny', value: null },
                { key: 'min', value: null },
                { key: 'max', value: null },
            ]
        },
        formAgent: {
            id: '',
        },
        agentFees: [],
        agentFields: [
            { key: 'name', label: 'Agente', sortable: true },
            { key: 'agent_id', label: '', sortable: false,  visible: false }, // Added agent_id key
            { key: 'value', label: 'Valor', sortable: false, tdClass: 'text-center' },
            { key: 'type', label: 'Tipo de Tarifa', sortable: false, tdClass: 'text-center' },
        ],
        loading: false,
        isBusy: true,
        search: '',
        fields: [
            { key: 'payer', label: 'Corresponsal', sortable: false },
            { key: 'payer_id', label: 'Pagador', sortable: false },
            { key: 'range', label: 'Rango', sortable: false },
            { key: 'value', label: 'Valor', sortable: false },
            { key: 'com', label: 'Costo', sortable: false },
            { key: 'country', label: 'País', sortable: false },
            { key: 'actions', label: 'Acción', sortable: false, thClass: 'text-center', tdClass: 'text-center' }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }],
        currentFeeId: null,
        editAgent: {
            id: 0,
            agent: '',
            value: 0,
            type: '='
        }
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'feepage');
        this.totalRows = this.items.length;
        this.getIni();
    },
    methods: {
        getIni() {
            axios.get('/api/settings/fee').then((res) => {
                if (res.data.status === 'success') {
                    this.items = res.data.items;
                    this.totalRows = this.items.length;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
            });
            this.timeout = setTimeout(this.getIni, 180000);
        },
        infoData(id) {
            this.form = {
                id: 0,
                item: null,
                payer: null,
                payer_id: null,
                value: 0,
                com: 0,
                currency: null,
                range: null,
                country: 'CL',
                check_apply_all: 0,
                values: [
                    { key: 'payer', value: null },
                    { key: 'payer_id', value: null },
                    { key: 'value', value: 0 },
                    {
                        key: 'type', value: null, items: [
                            { code: '=', name: 'Valor Fijo' },
                            { code: '%', name: 'Porcentaje' }
                        ]
                    },
                    { key: 'com', value: 0 },
                    {
                        key: 'tc', value: null, items: [
                            { code: '=', name: 'Valor Fijo' },
                            { code: '%', name: 'Porcentaje' }
                        ]
                    },
                    { key: 'tax', value: 0.19 },
                    { key: 'currency', value: 'USD' },
                    { key: 'country', value: null },
                    { key: 'destiny', value: null },
                    { key: 'min', value: null },
                    { key: 'max', value: null },
                ]
            };
            if (id) {
                const items = this.items;

                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                        this.form = items[i];
                    }
                }
            }
        },
        save(id) {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;
                let url = 'add';
                if (id) {
                    url = id + '/edit';
                }
                let formData = new FormData();
                formData.append('id', this.form.id);
                console.log(`FORM:`, JSON.stringify(this.form, null, 2))
                formData.append('values', JSON.stringify(this.form.values));
                formData.append('check_apply_all', this.form.check_apply_all);
                axios.post('/api/settings/fee/' + url, formData, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        this.getIni();
                        this.$bvModal.hide('data');
                        this.infoData();
                        this.$validator.reset();
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        saveAgentTariff() {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;
                let url = 'edit';
                let formData = new FormData();
                const payload = {
                    feeId: this.currentFeeId,
                    fees: this.agentFees
                };
                console.log(`PAYLOAD:`, payload)
                formData.append('payload', JSON.stringify(payload));
                axios.post('/api/settings/partner-fee/' + url, formData, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        // this.getIni();
                        this.$bvModal.hide('dataAgent');
                        this.infoData();
                        this.$validator.reset();
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        trash(id) {
            let name = '';
            const items = this.items;

            for (let i = 0; i < items.length; i++) {
                if (items[i].id === id) {
                    name = items[i].name;
                }
            }

            this.$swal({
                title: '¿Estas seguro de eliminar esta configuración de tarifa?',
                text: 'Tipo de Tarifa: ' + name,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, eliminar',
                confirmButtonColor: '#28a745',
                cancelButtonText: 'En otro momento',
                cancelButtonColor: '#dc3545',
                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    axios.get('/api/settings/fee/' + id + '/delete').then((res) => {
                        if (res.data.status === 'success') {
                            for (let i = 0; i < items.length; i++) {
                                if (items[i].id === id) {
                                    items.splice(i, 1);
                                    this.totalRows = this.items.length;
                                }
                            }
                        }
                    }).catch(err => {
                        this.$root.$bvToast.toast(err.response.data.errors, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    });
                }
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        },
        showAgentModal(feeId) {
            console.log(`FEE ID: ${feeId}`)
            this.currentFeeId = feeId;
            // Here you would fetch the agent fees for the given feeId from your API
            // For now, we'll just use some dummy data
            this.agentFees = [];
            axios.get(`/api/partner/list/${feeId}`).then((res) => {
                console.log(`RES.DATA:`, res.data)
                if (res.data.status === 'success') {
                    this.agentFees = res.data.items;
                    // this.agentFees = res.data.items.map(item => ({
                    // id: item.id,
                    // agent: item.name, // Add the agent name
                    // value: 0, // Default value
                    // type: '=', // Default type
                    //}));
                }
            }).catch(err => {
                console.info(`LIST ERR:`,err)
            })
        },
        addAgentFee() {
            this.editAgent = {
                id: 0,
                agent: '',
                value: 0,
                type: '='
            };
            this.$bvModal.show('editAgent');
        },
        editAgentFee(agentFee) {
            this.editAgent = { ...agentFee };
            this.$bvModal.show('editAgent');
        },
        deleteAgentFee(agentFee) {
            // Here you would delete the agent fee from the agentFees array
            this.agentFees = this.agentFees.filter(a => a.id !== agentFee.id);
        },
        handleCheckboxChange(isChecked) {
            const checkbox = document.getElementsByName("check_apply_all")[0];
            console.log("Checkbox is checked:", isChecked);
        },
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>
</style>

